import { type ChangeEvent, type FC, useCallback, useRef, useState } from 'react'

import { useUnit } from 'effector-react'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { TextField } from '@/components/ui/text-field.tsx'
import type { DialogProps } from '@/dialogs/types'
import { createVaultCategoryFx } from '@/models/vault/categories.ts'

export interface Props extends DialogProps {}

export const VaultAddCategoryDialog: FC<Props> = ({ isOpen, onClose }) => {
  const [newCategoryName, setNewCategoryName] = useState('')
  const isLoading = useUnit(createVaultCategoryFx.pending)
  const inputRef = useRef<HTMLInputElement>(null)

  const handleNewCategoryNameChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) =>
      setNewCategoryName(event.target.value),
    [],
  )

  const handleSave = useCallback(async () => {
    await createVaultCategoryFx(newCategoryName)
    onClose()
  }, [newCategoryName, onClose])

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
      initialFocus={inputRef}
    >
      <Dialog.Header>
        <Dialog.Title>Create New Category</Dialog.Title>
      </Dialog.Header>

      <div className="mt-5">
        <label className="text-title mb-1 block text-sm font-medium">
          Category Name
        </label>
        <TextField
          ref={inputRef}
          onChange={handleNewCategoryNameChange}
          value={newCategoryName}
          maxLength={64}
        />
        <p className="text-text-sub mt-1 text-right text-xs">
          {newCategoryName.length} / 64
        </p>
      </div>

      <Dialog.Footer>
        <Button
          id="tete"
          variant="outline"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          isLoading={isLoading}
          onClick={handleSave}
          disabled={!newCategoryName.length}
        >
          Save
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
